import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { PartyPopper, Eye } from "lucide-react";
import { api } from "@/lib/apiClient";

const WORDS = {
  first_visitor: { icon: Eye, eyebrow: "Your first visitor", title: "Someone just discovered Xcelio through you.", sub: "That's how it starts. One share, one person." },
  first_member: { icon: PartyPopper, eyebrow: "Your first member", title: "You've introduced someone to Xcelio.", sub: "And earned your first commission." },
};

// Celebrates a partner's first visitor and first member, once each.
export default function Celebration({ keys }) {
  const [queue, setQueue] = useState(keys || []);
  useEffect(() => setQueue(keys || []), [keys]);
  const cur = queue[0];
  const close = () => { api.post("/partner/celebrated", { key: cur }).catch(() => {}); setQueue((q) => q.slice(1)); };
  const w = WORDS[cur];
  return (
    <AnimatePresence>
      {w && (
        <motion.div key={cur} initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} onClick={close}
          className="fixed inset-0 z-[110] flex items-center justify-center bg-black/70 backdrop-blur-md px-6" data-testid={`celebration-${cur}`}>
          <motion.div initial={{ scale: 0.92, y: 20 }} animate={{ scale: 1, y: 0 }} transition={{ type: "spring", damping: 18 }} onClick={(e) => e.stopPropagation()}
            className="relative max-w-md w-full rounded-3xl border border-primary/30 bg-[#0b1220] p-8 text-center overflow-hidden">
            {Array.from({ length: 18 }).map((_, i) => (
              <motion.span key={i} className="absolute w-1.5 h-1.5 rounded-full" style={{ left: "50%", top: "38%", background: i % 3 ? "#4FB6C4" : "#F5D08A" }}
                initial={{ x: 0, y: 0, opacity: 1 }} animate={{ x: Math.cos(i * 0.35) * (120 + (i % 4) * 30), y: Math.sin(i * 0.35) * (90 + (i % 3) * 30), opacity: 0 }}
                transition={{ duration: 1.6, delay: 0.15, ease: "easeOut" }} />
            ))}
            <span className="mx-auto w-16 h-16 rounded-full bg-primary/15 text-primary flex items-center justify-center"><w.icon className="w-7 h-7" /></span>
            <p className="text-[10px] uppercase tracking-[0.28em] text-primary mt-6">{w.eyebrow}</p>
            <p className="font-serif text-3xl leading-tight mt-3">{w.title}</p>
            <p className="text-muted-foreground mt-3">{w.sub}</p>
            <button onClick={close} className="mt-8 rounded-full bg-primary text-primary-foreground px-8 py-3 font-medium" data-testid="celebration-close">Lovely</button>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
